import { Component, AfterViewInit, ViewChild } from '@angular/core';
import {GeneralService } from "../services/general.service"
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
@Component({
  selector: 'app-param-comp',
  templateUrl: './param-comp.component.html',
  styleUrls: ['./param-comp.component.scss']
})
export class ParamCompComponent implements AfterViewInit 
{

  data={GRHComp_Code:"",GRHComp_Libelle:""};


  listBtnCompetance = 
  [{name:"modifierCompetance",class:"colorGreen",text:"Enregistrer",icon : "save",disabled : false},
  {name:"supprimerCompetance",class:"colorRed",text:"Supprimer",icon : "delete",disabled : false}]
  datasource= [];
  @ViewChild(AvtListesComponent,{static:false}) listeCompetenceComponen : AvtListesComponent;
    Columns={"TableRD":[
      {"TableRE_Code":"avtAlerte","TableRD_Champs":"GRHComp_Code","Lg_Code":"GRHComp_Code","TableRD_Des":"Code","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"avtAlerte","TableRD_Champs":"GRHComp_Libelle","Lg_Code":"GRHComp_Libelle","TableRD_Des":"Libelle","TableRD_Largeur":400,"TableRD_ReadOnly":false,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}]}
  exist=true;
  
  constructor(public generalService:GeneralService) { }

  ngAfterViewInit() 
  {    
    this.setCompetence(false);

  }
  setCompetence(showMessage)
  {
    this.generalService.rechercheTable(this.generalService.urlListCompetence).subscribe( comp => 
    {
      this.datasource = comp;
      this.listeCompetenceComponen.setDataSource(this.datasource); 
      this.exist = true;
      if(showMessage)
      {
        this.generalService.dialogSuccess("Enregistré",true);
      }
    })    
  }
  ajouter(f)
  {
    if (f.form.valid) 
    {
      var findComp = this.datasource.find(comp => {return comp.GRHComp_Libelle.trim().toLowerCase() == this.data.GRHComp_Libelle.trim().toLowerCase()})
      if(findComp == undefined)
      {
        this.exist = false;
        this.enregistrer("ajouter",this.data);     
      }
      else
      this.generalService.dialogSuccess("Ce nom du compétence existe déjà",false)
    }
  }
  supprimer(competance)
  {
    if(this.generalService.isNotEmpty(competance))
    {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(competance.GRHComp_Code,"GRHComp");
          if(deleteFn != null)
          {
            deleteFn.subscribe(data => 
            {
              this.generalService.dialogSuccess("Supprimer",true);
              this.setCompetence(false);
            })
          }
        }
      })
            
    }
    else
        this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
  modifier(competance)
  {
    if(this.generalService.isNotEmpty(competance))
    {
      if( this.generalService.isNotEmpty(competance.GRHComp_Libelle))
      {
        var findComp = this.datasource.find(comp => {return comp.GRHComp_Libelle.trim().toLowerCase() == competance.GRHComp_Libelle.trim().toLowerCase() && competance.GRHComp_Code != comp.GRHComp_Code})
        if(findComp == undefined)
        {
          this.exist = false;
          this.enregistrer("modifier",competance);      
        }
        else
        this.generalService.dialogSuccess("Ce nom du compétence existe déjà",false)
      }
      else
        this.generalService.dialogSuccess("Le champ de libellé  ne peut pas être vide",false)
    }
    else
        this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
  enregistrer(mode,competance)
  {
    this.listBtnCompetance.forEach(btn =>
    {
      btn.disabled = true;
    })
    var url :string = this.generalService.urlCompetance;
    if(mode == "modifier")
      url += "&val="+competance.GRHComp_Code
    this.generalService.rechercheTable(url).subscribe(data => 
    {
      data.GRHComp[0].GRHComp_Libelle =  competance.GRHComp_Libelle;
      this.generalService.enregisterTable(data).subscribe(data => 
      {
        this.listBtnCompetance.forEach(btn =>
        {
          btn.disabled = false;
        })
        this.setCompetence(true)
      },
      err =>
      {
        this.exist = true;
      });
    },
    err =>
    {
      this.exist = true;
    });
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "modifierCompetance":
      {
        this.modifier(event.row);
        break;
      }
      case "supprimerCompetance":
      {
        this.supprimer(event.row)
        break;
      }
    }
  }
}
